// Route table. /login is standalone (first touch). Everything else renders
// inside the app shell (the sidebar IS the vault list + a top bar), including
// the vault content view (/v/:vaultId/*) — which lives in the shell, with the
// vault-name breadcrumb in the header and its file tree in the content area
// (decisions/90-vault-layout.md). There's no standalone vaults page: "/"
// resolves to the caller's first vault (or a no-vault empty state) via
// VaultIndex. Management pages each wrap themselves in a role gate for direct
// URL hits.

import { Navigate, Route, Routes } from "react-router-dom";
import { LoginPage } from "./pages/LoginPage";
import { VaultIndex } from "./pages/VaultIndex";
import { VaultPage } from "./pages/VaultPage";
import { UsersPage } from "./pages/UsersPage";
import { ServerPage } from "./pages/ServerPage";
import { AccountPage } from "./pages/AccountPage";
import { DocsPage } from "./pages/DocsPage";
import { AppShell } from "./app/AppShell";
import { RequireAuth } from "./session";

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route
        element={
          <RequireAuth>
            <AppShell />
          </RequireAuth>
        }
      >
        <Route path="/" element={<VaultIndex />} />
        <Route path="/v/:vaultId/*" element={<VaultPage />} />
        <Route path="/users" element={<UsersPage />} />
        <Route path="/server" element={<ServerPage />} />
        <Route path="/account" element={<AccountPage />} />
        <Route path="/docs" element={<DocsPage />} />
        <Route path="/docs/:slug" element={<DocsPage />} />
        {/* The pre-docs quick-start URL; keep old links working. */}
        <Route path="/quickstart" element={<Navigate to="/docs/quickstart" replace />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
